import { HttpClient } from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from '@environments/environment';
import { GlobalDataService } from '@providers/global-data/global-data.service';
import { UtilsService } from '@providers/utils/utils.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@auth0/angular-jwt/src/jwthelper.service";
import * as i3 from "../global-data/global-data.service";
import * as i4 from "../utils/utils.service";
var AuthService = /** @class */ (function () {
    function AuthService(http, jwtHelper, globalDataService, utils) {
        this.http = http;
        this.jwtHelper = jwtHelper;
        this.globalDataService = globalDataService;
        this.utils = utils;
        this.url = environment.auth_url + "/?redirect=";
    }
    AuthService.prototype.isAuthenticated = function () {
        var token = this.jwtHelper.tokenGetter();
        if (typeof token !== 'undefined' && !this.jwtHelper.isTokenExpired(token)) {
            return true;
        }
        return false;
    };
    AuthService.prototype.redirectOAuth = function () {
        var currentUrl = document.URL;
        window.open(this.url + encodeURIComponent(currentUrl), '_self');
    };
    AuthService.prototype.retrieveTokenFromUrl = function () {
        var params = this.utils.extractUrlParams();
        if (params['token']) {
            localStorage.setItem('access_token', params['token']);
        }
    };
    AuthService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthService_Factory() { return new AuthService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.JwtHelperService), i0.ɵɵinject(i3.GlobalDataService), i0.ɵɵinject(i4.UtilsService)); }, token: AuthService, providedIn: "root" });
    return AuthService;
}());
export { AuthService };
